import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { ActiveRollout, FleetSummary, ReleaseSnapshot } from '@/components/features/dashboard';

/**
 * Monitoring, laid out as the design draws it.
 *
 * Three sections, each with a brand-ruled heading, 26px apart. The order is
 * the design's and it is the right one: what is shipping right now, then how
 * the estate is behaving, then what is published. Somebody opening this screen
 * during a rollout wants the rollout first.
 *
 * No page heading here - the shell's 80px header already carries "Monitoring
 * Dashboard", and a second one under it is duplication.
 */
export function DashboardPage() {
  return (
    <>
      <Meta title="Monitoring" />

      <Container className="space-y-6.5">
        <ActiveRollout />
        <FleetSummary />
        <ReleaseSnapshot />
      </Container>
    </>
  );
}
